import React, { useContext, useEffect, useState } from "react";
import style from "./AllTransactions.module.css";
import { DashboardContext } from "../../../../context/DashboardContext";
import { AuthContext } from "../../../../context/AuthContext";
import client from "../../../../api/client";

const AllTransactions = () => {
  const { transactions, nityaSevaTransactions } = useContext(DashboardContext);
  const { fetchDashboardData } = useContext(DashboardContext);
 const [userData, setUserData] = useState({});
  const { user } = useContext(AuthContext);

const download80G = (receiptLink, is80G) => {

  if(!receiptLink) {
    alert("Receipt link not available");
    return;
  }
  const link = document.createElement("a");

  link.href = receiptLink;
  link.setAttribute(
    "download",
    `${is80G ? "80G" : "Non-80G"}-Certificate.pdf`
  );

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

  useEffect(() => {
    if (typeof fetchDashboardData === "function") fetchDashboardData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // fetch once on mount

  const handleDownload80G = (receiptLink,is80G=true) => {
    download80G(receiptLink,is80G);
  };

  const getUserDetails = async () => {
    try {
      const res = await client.get(`/get-user-details`, {
        params: {
          icsid: user.icsid,
          phone: user.mobile,
          mode: 'DETAILED_WITH_DONATIONS'
        }
      });
      const data = res.data?.data?.[0];
      if (data) {
        console.log("User details fetched successfully", data);
        setUserData(data);
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    getUserDetails();
  }, []);

  const handleDetails = (receiptNo) => {
    alert(`Showing details for receipt: ${receiptNo}`);
    // replace with real show-details action
  };

  return (
    <div className={style.container}>
      {/* All Transactions Section */}
      <div className={style.section}>
        <h2 className={style.title}>All Transactions</h2>
        <table className={style.table}>
          <thead>
            <tr>
              <th>Date</th>
              <th>Status</th>
              <th>Name</th>
              <th>Amount</th>
              <th>Download</th>
            </tr>
          </thead>
          <tbody>
            {userData.donations?.length > 0 ? (
              userData.donations?.map((txn) => (
                <tr key={txn.id}>
                  <td>{txn.createdAt}</td>
                  <td>{txn.status}</td>
                  <td>{txn.name}</td>
                  <td>₹{txn.amount}</td>
                  <td>
                    <button
                      className={style.downloadBtn}
                      onClick={() => handleDownload80G(txn.pdfLink, txn.taxBenifit)}
                    >
                      Download Receipt
                    </button>
                  </td>
                  {/* <td>
                    <button className={style.downloadBtn}>
                      TRACK
                    </button>
                  </td> */}
                </tr>
              ))) : (
              <tr>
                <td colSpan="5" className={style.noData}>
                  No transactions found.
                </td>
              </tr>
            )}
            </tbody>
          </table>
        </div>
      <div className={style.section}>
        <h2 className={style.title}>Nitya Seva</h2>

        <div className={style.tableWrapper}>
          <table className={style.table} aria-label="Nitya Seva Transactions">
            <thead>
              <tr>
                <th>Purpose</th>
                <th>Date</th>
                <th>Status</th>
                <th>Name</th>
                <th>Amount</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {nityaSevaTransactions.length > 0 ? (
                nityaSevaTransactions.map((txn) => (
                  <tr key={txn.id || txn.receiptNo}>
                    <td data-label="Purpose">{txn.purpose}</td>
                    <td data-label="Date">{txn.date}</td>
                    <td data-label="Status">{txn.status}</td>
                    <td data-label="Name">{txn.name}</td>
                    <td data-label="Amount">₹{txn.amount}</td>
                    <td data-label="Action">
                      <button
                        className={`${style.downloadBtn} ${style.smallAction}`}
                        onClick={() => handleDetails(txn.receiptNo)}
                      >
                        DETAILS
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className={style.noData}>
                    No Nitya Seva transactions found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AllTransactions;
